import { Blockchain } from "@rarible/api-client"
import { base } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const baseConfig: StaticEthereumBlockchainConfig = {
  name: "Base",
  icon: "/images/blockchains/base.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://base-api.rarible.org",
  chainId: base.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.BASE,
  chainName: base.name,
  exchange: {
    v2: "0x6C65a3C3AA67b126e43F86DA85775E0F5e9743F7",
    wrapper: "0x6563a331A411829918025D8a7e1d348f8b250906",
  },
  blockExplorers: [
    {
      url: "https://basescan.org/",
      icon: "/images/scanner.svg",
      adress: "https://basescan.org//address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "base-node",
  transferProxies: {
    nft: "0x4217a346C8b48731641327b65bb6F6d3243d64e2",
    erc721Lazy: "0x339e61eb644A29B134D7fD3fA589C6b3ca184111",
    erc20: "0x13b05523634ABb96E6017Da71b7698CAecDf50b2",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("BASE:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("BASE:0x4200000000000000000000000000000000000006"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/base/swap",
  hasStabilityProtocol: true,
  viem: base,
}

export const getBaseConfig = (): StaticEthereumBlockchainConfig => baseConfig
